module.exports = __webpack_public_path__ + "img/1P.4121b973.jpg";